import OModalItemDetails4 from './o-modal-item-details-4.vue';

export default OModalItemDetails4;